import { ticket_promotion_mechanics } from "@assets/constants/ticket_promotion_mechanics";

export const isTicketPromotion = (mechanic: string) => ticket_promotion_mechanics.includes(mechanic ?? '')